import { Notifications } from "@/features/settings/notifications";

export const Route = createFileRoute({
  component: Notifications,
});
